import "core-js/modules/web.dom-collections.iterator.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/header-logo-whitebg.png';
import _imports_1 from '../assets/image/header-logo-blackbg.png';
const _withScopeId = n => (_pushScopeId("data-v-5a4284e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "item-first"
};
const _hoisted_2 = {
  class: "logo",
  href: "/"
};
const _hoisted_3 = {
  key: 0,
  src: _imports_0
};
const _hoisted_4 = {
  key: 1,
  src: _imports_1
};
const _hoisted_5 = {
  class: "cate-box"
};
const _hoisted_6 = ["href", "target", "onMousemove"];
const _hoisted_7 = {
  key: 0,
  class: "hot"
};
const _hoisted_8 = {
  key: 0,
  class: "drop-box"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "flex-start"
};
const _hoisted_11 = {
  class: "drop-img"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "drop-name"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "drop-right"
}, "→", -1));
const _hoisted_15 = {
  key: 0,
  class: "drop-box copyright"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "flex-start"
};
const _hoisted_18 = {
  class: "drop-img"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "drop-name"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "drop-right"
}, "→", -1));
const _hoisted_22 = {
  key: 0,
  class: "drop-box copyright2"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  class: "flex-start"
};
const _hoisted_25 = {
  class: "drop-img"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "drop-name"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "drop-right"
}, "→", -1));
const _hoisted_29 = {
  class: "item"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_31 = {
  class: "nickname single-line-ellipsis"
};
const _hoisted_32 = {
  key: 0,
  class: "logout"
};
const _hoisted_33 = {
  href: "/account/welcome"
};
const _hoisted_34 = {
  href: "/account/order"
};
const _hoisted_35 = {
  href: "/account/collect"
};
const _hoisted_36 = {
  href: "/account/coupon"
};
const _hoisted_37 = ["href"];
const _hoisted_38 = {
  href: "/cyprotect/myorderinfo"
};
const _hoisted_39 = {
  href: "/creator/works"
};
const _hoisted_40 = {
  key: 0,
  class: "history-ul"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "history-name"
}, "历史记录", -1));
const _hoisted_42 = {
  target: "_blank",
  class: "upload-box"
};
const _hoisted_43 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_router_link = _resolveComponent("router-link");
  const _component_v_avatar = _resolveComponent("v-avatar");
  const _component_User = _resolveComponent("User");
  const _component_ElIcon = _resolveComponent("ElIcon");
  const _component_Tickets = _resolveComponent("Tickets");
  const _component_Star = _resolveComponent("Star");
  const _component_Ticket = _resolveComponent("Ticket");
  const _component_Avatar = _resolveComponent("Avatar");
  const _component_ElDivider = _resolveComponent("ElDivider");
  const _component_Upload = _resolveComponent("Upload");
  const _component_history_list = _resolveComponent("history-list");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", {
      fixed: $data.isFixed
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "item",
    onMouseleave: _cache[0] || (_cache[0] = (...args) => $options.dropMouseLeave && $options.dropMouseLeave(...args))
  }, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "拖动Logo至上方书签栏，收藏中国V链",
    placement: "bottom-start"
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_2, [$data.isFixed ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), !$data.isFixed ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true)])]),
    _: 1
  }), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.title, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      key: index,
      class: _normalizeClass(["cate-item", {
        active: $options.active === index,
        'flex-align-center': item.hot
      }]),
      href: item.url,
      target: item.target,
      onMousemove: $event => $options.dropMouseEnter(index)
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1), item.hot ? (_openBlock(), _createElementBlock("span", _hoisted_7, "HOT")) : _createCommentVNode("", true)], 42, _hoisted_6);
  }), 128)), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showDrop ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dropList, (items, k) => {
      return _openBlock(), _createElementBlock("div", {
        class: "flex-justify",
        key: k,
        onClick: $event => $options.dropCki(items)
      }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        src: items.img,
        alt: ""
      }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, _toDisplayString(items.name), 1)]), _hoisted_14], 8, _hoisted_9);
    }), 128))])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showCopyrightDrop ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.copyrightDropList, (items, k) => {
      return _openBlock(), _createElementBlock("div", {
        class: "flex-justify",
        key: k,
        onClick: $event => $options.dropCki(items)
      }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: items.img,
        alt: ""
      }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, _toDisplayString(items.name), 1)]), _hoisted_21], 8, _hoisted_16);
    }), 128))])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showCopyrightProtectionDrop ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.copyrightDropList2, (items, k) => {
      return _openBlock(), _createElementBlock("a", {
        href: items.url,
        class: "flex-justify",
        key: k
      }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
        src: items.img,
        alt: ""
      }, null, 8, _hoisted_26)]), _createElementVNode("div", _hoisted_27, _toDisplayString(items.name), 1)]), _hoisted_28], 8, _hoisted_23);
    }), 128))])) : _createCommentVNode("", true)]),
    _: 1
  })])], 32), $options.isShowSearchBox ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["item header-search-box", {
      cySearch: $data.isCy && !$data.isFixed,
      dpSearch: $data.isDeposit && !$data.isFixed
    }])
  }, [_createVNode(_component_el_select, {
    class: "select-types",
    modelValue: $data.searchType,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.searchType = $event),
    placeholder: "请选择素材类型",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.searchTypeOption, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["keyword-input", {
      ckeyinput: $data.isCy && !$data.isFixed,
      dpkeyinput: $data.isDeposit && !$data.isFixed
    }]),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.keyword = $event),
    type: "text",
    onKeyup: _cache[3] || (_cache[3] = _withKeys((...args) => $options.onSearch && $options.onSearch(...args), ["enter"])),
    placeholder: "输入关键词搜索素材或创作人"
  }, null, 34), [[_vModelText, $data.keyword]]), _createElementVNode("div", {
    class: "header-search-button flex-align-center",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.onSearch && $options.onSearch(...args))
  })], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_createVNode(_component_router_link, {
    to: {
      path: '/cart',
      query: {
        ..._ctx.$route.query,
        fpos: 'HeaderPage'
      }
    },
    target: "_blank"
  }, {
    default: _withCtx(() => [_hoisted_30]),
    _: 1
  }, 8, ["to"]), _ctx.$userInfo.id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "userinfo-box flex-align",
    onMouseleave: _cache[7] || (_cache[7] = $event => $data.showUserDialog = false)
  }, [_createVNode(_component_router_link, {
    to: "/account",
    target: "_blank",
    class: "flex-align",
    onMousemove: _cache[5] || (_cache[5] = $event => $data.showUserDialog = true)
  }, {
    default: _withCtx(() => [_createVNode(_component_v_avatar, {
      to: "/account",
      user: _ctx.$userInfo
    }, null, 8, ["user"]), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$userInfo.username), 1)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showUserDialog ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("a", _hoisted_33, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_User)]),
      _: 1
    }), _createTextVNode(" 个人中心 ")])]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_34, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Tickets)]),
      _: 1
    }), _createTextVNode(" 素材订单 ")])]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_35, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Star)]),
      _: 1
    }), _createTextVNode(" 我的收藏 ")])]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_36, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Ticket)]),
      _: 1
    }), _createTextVNode(" 我的优惠券 ")])]), _createElementVNode("li", null, [_createElementVNode("a", {
      href: `/personalcollect/${_ctx.$userInfo.id}`
    }, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Avatar)]),
      _: 1
    }), _createTextVNode(" 我的素材主页 ")], 8, _hoisted_37)]), _createVNode(_component_ElDivider, {
      style: {
        "margin": "12px 0"
      }
    }), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_38, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Tickets)]),
      _: 1
    }), _createTextVNode(" 版权订单 ")])]), _createVNode(_component_ElDivider, {
      style: {
        "margin": "12px 0"
      }
    }), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_39, [_createVNode(_component_ElIcon, null, {
      default: _withCtx(() => [_createVNode(_component_Upload)]),
      _: 1
    }), _createTextVNode(" 素材管理 ")])])]), _createVNode(_component_ElDivider, {
      style: {
        "margin": "12px 0"
      }
    }), _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = (...args) => $options.logout && $options.logout(...args)),
      class: "pointer"
    }, "退出登录")])) : _createCommentVNode("", true)]),
    _: 1
  })], 32)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "login",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.login && $options.login(...args))
  }, "登录/注册")), _createElementVNode("div", {
    class: "history-box",
    onMouseleave: _cache[12] || (_cache[12] = $event => $data.showUserHistory = false)
  }, [_createElementVNode("div", {
    class: "icon-history",
    onMousemove: _cache[9] || (_cache[9] = $event => $data.showUserHistory = true),
    onClick: _cache[10] || (_cache[10] = (...args) => $options.enterHistory && $options.enterHistory(...args))
  }, null, 32), _ctx.$userInfo.id ? (_openBlock(), _createBlock(_Transition, {
    key: 0,
    name: "fade",
    onMousemove: _cache[11] || (_cache[11] = $event => $data.showUserHistory = true)
  }, {
    default: _withCtx(() => [$data.showUserHistory ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_hoisted_41, $data.imgList && $data.imgList ? (_openBlock(), _createBlock(_component_history_list, {
      key: 0,
      list: $data.imgList
    }, null, 8, ["list"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)], 32), _createElementVNode("div", _hoisted_42, [_createElementVNode("a", {
    href: $options.uploadUrl,
    class: "upload",
    target: "_blank"
  }, "上传", 8, _hoisted_43)])])])], 2);
}